import React from 'react'
import { useFormContext } from 'react-hook-form'

import TextElement from '@/components/text-element/text-element'
import { formMessages } from '@/constants/form-messages'
import { type FormWebsite } from '@/internal/types/form'

import EmailField from '../fields/email'

type Props = {
  title?: string
  subtitle?: string
}

const StepMail: React.FC<Props> = ({ title, subtitle }) => {
  const { getValues } = useFormContext()
  const values = getValues() as FormWebsite
  const labels = formMessages[values.form]
  return (
    <>
      <TextElement type="h2" text={title ?? labels.stepMailTitle} />
      <TextElement type="h3" text={subtitle ?? labels.stepMailSubtitle} />
      <EmailField align="centerLabel" />
    </>
  )
}

export default StepMail
